export const ICON_TYPES = [
  'note',
  'home-trend-up',
  'box',
  'burger',
  'burger-close',
  'search',
  'search-sm',
  'external',
  'nav-bar-search',
  'express',
  'express-fill',
  'chevron',
  'chevron-fill',
  'chevron-2-fill',
  'nav-bar-fav',
  'nav-bar-fav-fill',
  'fav',
  'fav-fill',
  'profile',
  'bag',
  'insta',
  'fb',
  'apple',
  'gplay',
  'arrow',
  'star',
  'star-fill',
  'percent',
  'trash',
  'minus',
  'plus',
  'edit',
  'badge',
  'like',
  'like-fill',
  'share',
  'info',
  'check',
  'mc',
  'gpay',
  'apay',
  'apay2',
  'cash',
  'add-card',
  'shield',
  'card',
  'menu-personal',
  'logout',
  'subscription',
  'calendar',
  'notification',
  'notification-not',
  'notificationV2',
  'notificationV2-not',
  'cards',
  'orders',
  'location',
  'document',
  'message',
  'link',
  'friends',
  'promocodes',
  'refferal',
  'filter',
  'filter-alt',
  'whatsapp',
  'whatsapp-orig',
  'phone',
  'bonus',
  'copy',
  'difficulty',
  'time',
  'fire',
  'play',
  'home',
  'home-edit',
  'pin',
  'geolocation',
  'check-round',
  'check-round-3.1',
  'marker',
  'spinner',
  'verified',
  'warning',
  'refresh',
  'person',
  'express-round',
  'card-add',
  'check-circled',
  'close',
  'home-fill',
  'explore',
  'explore-fill',
  'search-fill',
  'search-alt',
  'cabinet',
  'cabinet-fill',
  'filters',
  'sort',
  'sort-alt',
  'promocode',
  'people',
  'shop',
  'calendar-2',
  'envelope',
  'tiktok',
  'youtube',
  'back',
  'double-back',
  'close-round',
  'map',
  'receipt',
  'express-disabled',
  'person-other',
  'status-delivered',
  'status-packaging',
  'status-delivering',
  'delivery-pin-mid',
  'delivery-pin-max',
  'warehouse-pin',
  'house-pin',
  'location-pin',
  'location-fill-pin',
  'ellipses',
  'ellipses-vertical',
  'visible',
  'visible-not',
  'time-fill',
  'whatsapp-fill',
  'nav-bar-search-fill',
  'bag-fill',
  'chevron-double',
  'fresh-chat',
  'insta',
  'facebook',
  'twitter',
  'flash-fill',
  'rate-stars-circle',
  'standard-delivery',
  'empty-wallet',
  'shop-building',
  'expand',
  'shopping-bag',
  'shopping-bag-check',
  'done-all',
  'reorder',
  'linkedin',
  'pay_gpay',
  'pay_apple',
  'pay_visa',
  'pay_mc',
  'pay_jcb',
  'pay_amex',
  'pay_discover',
  'navbar_home',
  'navbar_shop',
  'navbar_cart',
  'navbar_cabinet',
  'navbar_favs',
  'profile-new',
  'coins',
  'percents',
  'dialog',
  'message_contact_us',
  'favs-3.1',
  'profile-3.1',
  'cart-3.1',
  'catalog-3.1',
  'plus-3.1',
  'minus-3.1',
  'favs-card-3.1',
  'favs-card-fill-3.1',
  'notify-3.1',
  'notify-fill-3.1',
  'chevron-3.1',
  'chevron-3.1-right',
  'sommelier-3.1',
  'check-3.1',
  'arroy-right-3.1',
  'mark-3.1',
  'support-3.1',
  'flash-3.1',
  'star-3.1',
  'coins-3.1',
  'box-opened',
  'bike',
  'puzzle-piece',
  'user',
  'user-fill',
  'chevron-up',
  'chevron-right',
  'copy-alt',
  'heart',
  'message_text_circle',
  'insta-outlined',
  'fb-outlined',
  'tiktok-outlined',
  'youtube-outlined',
  'minus-alt',
  'plus-alt',
  'link-external-01',
  'present',
  'flash',
  'file-box',
  'heart-fill',
  'pointer',
  'pinV3',
  'copy-promocode',
  'certificate',
  'plane',
  'sale',
  'box-de',
  'chat-circle',
  'star-badge',
  'camel-rating',
  'pay-cash-mono',
  'pay-gpay-mono',
  'pay-apple-mono',
  'pay-visa-mono',
  'pay-mc-mono',
  'pay-jcb-mono',
  'pay-amex-mono',
  'pay-discover-mono',
  'pay-unionpay-mono',
  'airtel',
  'moov',
  'qr-code',
  'timer',
  'wallet',
  'pack',
  'verif-audkenni',
  'verif-mobile',
  'fiscal-check',
] as const;

export const ICON_TYPES_NOT_TRL = [
  'insta-outlined',
  'fb-outlined',
  'tiktok-outlined',
  'youtube-outlined',
  'insta',
  'fb',
  'apay2',
  'apay',
  'apple',
  'gplay',
  'gpay',
  'apay',
  'whatsapp',
  'tiktok',
  'youtube',
  'fresh-chat',
  'insta',
  'facebook',
  'twitter',
  'reorder',
  'linkedin',
  'pay_gpay',
  'pay_apple',
  'pay_visa',
  'pay_mc',
  'pay_jcb',
  'pay_amex',
  'pay_discover',
  'pay_unionpay',
  'pointer',
  'pinV3',
  'camel-rating',
  'airtel',
  'moov',
  'qr-code',
] as const;

export type IconTypes = (typeof ICON_TYPES)[number];
